export default "__VITE_ASSET__6117b952__"